export const generateRandomString = (length = 6) => Math.random().toString(20).substr(2, length);

export const capitalize = text => text.toLowerCase().replace(/\b\w/g, m => m.toUpperCase());

export function getInitials(text, glue) {
    if (!text) return '';

    if (typeof glue == "undefined") {
        let glue = true;
    }

    let initials = text.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);

    if (glue) {
        return initials.join('').substring(0, 2);
    }

    return initials.join('').substring(0, 2).toUpperCase();
};

export const ucfirst = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export const replace = (s, searchvalue, newvalue) => {
    if (typeof s !== 'string') return '';

    return s.replace(searchvalue, newvalue);
}
